export default "__VITE_ASSET__ByntrgJ0__"